import { Component, computed, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext, DroplistItem, DroplistWidget } from '@eforall/dashboard';


enum ClassSpeakerChoice {
	Yes = 1,
	No = 0,
}

@Component({
	selector: 'entrepreneurs-set-class-speaker-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		DroplistWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './set-class-speaker.dialog.html',
})


export class SetClassSpeakerDialog implements OnInit {

	public dialogContext: DialogContext<{ accEntrepreneurId: number, isClassSpeaker: boolean }> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<SetClassSpeakerDialog>);

	public selection = signal<ClassSpeakerChoice | undefined>(undefined);

	saveActionEnabled = signal(false);

	saveAction: DialogAction = {
		id: 'save',
		cssClass: signal(undefined),
		enabled: this.saveActionEnabled,
		visible: signal(true),
		text: signal('Save'),
		linkType: 'callback',
		callback: async (): Promise<boolean> => this.selection() === ClassSpeakerChoice.Yes,
		willCloseDialog: true,
	};

	cancelAction: DialogAction = {
		id: 'close',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Close'),
		linkType: "no-action",
		willCloseDialog: true,
	};

	actions: DialogAction[] = [this.saveAction, this.cancelAction];

	public initialSelection = signal<DroplistItem | undefined>(undefined);
	public readonly droplistItems = computed<DroplistItem[]>(() => {
		return [{
			uniqueId: ClassSpeakerChoice.Yes,
			iconContext: {
				iconClass: 'fa-check',
				iconStyle: 'fa-solid',
				text: 'Yes',
				hideText: 'never',
			},
			customSort: 1
		},
		{
			uniqueId: ClassSpeakerChoice.No,
			iconContext: {
				iconClass: 'fa-xmark',
				iconStyle: 'fa-solid',
				text: 'No',
				hideText: 'never',
			},
			customSort: 2
		}];
	});


	ngOnInit(): void {
		const isClassSpeaker = this.dialogContext.data?.isClassSpeaker;
		if (isClassSpeaker != undefined) {
			this.selection.set(isClassSpeaker ? ClassSpeakerChoice.Yes : ClassSpeakerChoice.No);
			const selectedItem = this.droplistItems().find(e => e.uniqueId == this.selection());
			this.initialSelection.set(selectedItem);
		}
	}

	onViewDroplistChange(selectedItem: DroplistItem | undefined) {
		if (!selectedItem) return;
		this.selection.set(selectedItem?.uniqueId);
		this.saveActionEnabled.set(this.initialSelection()?.uniqueId !== selectedItem?.uniqueId);
	}

}
